import {Box, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

const SpotLightBadge = () => {
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      width={'fit-content'}
      my={1.25}
      p={0.7}
      borderRadius={'3px'}
      border="1px solid #fbf0dd"
      sx={{
        backgroundColor: '#fffcf7',
      }}
    >
      <Image
        src={
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUdwTOpkDOpkDetkDetkDepjDetlDvpvFvBqEOpkDOpkDeljDOpjDetkDexmDutkDP+BMupkDOpkDOpkDOpjDOljDLn7v+8AAAAVdFJOUwDQr1473UcLGOlr+YRTKXYFpr2P8Wgd5lgAAAHMSURBVEjH3ZbZdoQgDIZdWFUQ1Lz/qxYYOMUBBO1F28mdhO+Q5SfSdR9nSmIsH9MaQD+GB4Dhr8OMtsGUpewIB2mByQFjAm8AM6lXm8wAW+bklCZzumK2pSd3a4amNMOuuYo5Gl3VFBXZF61jdSIhkFSnGpRYR4d8lNAHODu0UN91mcpxyXAPRgyR4fHdf6WXHt6sZ62qRNwdtxOmFCO7C4KjRnaOIw05zE00s+fqU4OpLTNvmQs23+V9cbF5qyo7QnZ82LOn6twy+eH0cnbUrHNagUVe+K+IxvrMw3kPro4VZTS55127add13NIER/IuYlyZXoseW+tNNZHZUVAiMy7RdZPfLPwyDwpmrl6FdirXLBb28kgW7pu6mhYSow6m4aQ+BLQu1lb5SkyWy2F6Jf1mlt8hygpA1VYteddSziia8zxbMZvs1nAvsiqcGm6G4uWLcdQuhjsh1bDarqbu6aeV1swIGzbVOIaGUxvZYCXEmgcgj7oteOY3dj161/gvBBi1Dm5m896pN5dv89B/TbLY+K2nTP+bsEbe9AN4Z972f5XzzwpGvG0P4CUobLgL63PY2y2YnGFx76k9zd/ovNx9qDMxeROs+yz7Aq3NLcdCBLfPAAAAAElFTkSuQmCC'
        }
        alt={'spot_light'}
        width={20}
        height={20}
        style={{
          marginRight: 6,
        }}
      />
      <Box display={'flex'} alignItems={'center'} gap={'3px'}>
        <Typography variant="body2" color={'primary'}>
          Spotlight
        </Typography>
        <Typography variant="body2" color={'primary'}>
          :
        </Typography>
        <Typography variant="body3" color={'primary'}>
          ACTIVE
        </Typography>
      </Box>
    </Box>
  );
};

export default SpotLightBadge;
